interface TermsModalProps {
  type: 'terms' | 'privacy';
  onClose: () => void;
}

const TERMS_CONTENT = {
  terms: {
    title: '이용약관',
    sections: [
      {
        heading: '제1조 (목적)',
        body: '이 약관은 자연담은(이하 "회사")이 운영하는 인터넷 쇼핑몰(이하 "몰")에서 제공하는 인터넷 관련 서비스(이하 "서비스")를 이용함에 있어 회사와 이용자의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.',
      },
      {
        heading: '제2조 (정의)',
        body: '"몰"이란 회사가 재화 또는 용역을 이용자에게 제공하기 위하여 컴퓨터 등 정보통신설비를 이용하여 재화 또는 용역을 거래할 수 있도록 설정한 가상의 영업장을 말하며, 아울러 쇼핑몰을 운영하는 사업자의 의미로도 사용합니다.',
      },
      {
        heading: '제3조 (약관의 명시와 개정)',
        body: '회사는 이 약관의 내용과 상호 및 대표자 성명, 영업소 소재지 주소, 전화번호, 팩스번호, 전자우편주소, 사업자등록번호, 통신판매업 신고번호, 개인정보관리책임자 등을 이용자가 쉽게 알 수 있도록 몰의 초기 서비스화면에 게시합니다.',
      },
      {
        heading: '제4조 (서비스의 제공 및 변경)',
        body: '회사는 다음과 같은 업무를 수행합니다. 1. 재화 또는 용역에 대한 정보 제공 및 구매계약의 체결 2. 구매계약이 체결된 재화 또는 용역의 배송 3. 기타 회사가 정하는 업무',
      },
      {
        heading: '제5조 (회원가입)',
        body: '이용자는 회사가 정한 가입 양식에 따라 회원정보를 기입한 후 이 약관에 동의한다는 의사표시를 함으로서 회원가입을 신청합니다. 회사는 제1항과 같이 회원으로 가입할 것을 신청한 이용자 중 다음 각호에 해당하지 않는 한 회원으로 등록합니다.',
      },
      {
        heading: '제6조 (회원 탈퇴 및 자격 상실)',
        body: '회원은 회사에 언제든지 탈퇴를 요청할 수 있으며 회사는 즉시 회원탈퇴를 처리합니다. 회원이 다음 각호의 사유에 해당하는 경우, 회사는 회원자격을 제한 및 정지시킬 수 있습니다.',
      },
      {
        heading: '제7조 (구매신청)',
        body: '몰 이용자는 몰상에서 다음 또는 이와 유사한 방법에 의하여 구매를 신청하며, 회사는 이용자가 구매신청을 함에 있어서 다음의 각 내용을 알기 쉽게 제공하여야 합니다.',
      },
      {
        heading: '제8조 (청약철회 등)',
        body: '회사와 재화 등의 구매에 관한 계약을 체결한 이용자는 수신확인의 통지를 받은 날부터 7일 이내에는 청약의 철회를 할 수 있습니다.',
      },
    ],
  },
  privacy: {
    title: '개인정보처리방침',
    sections: [
      {
        heading: '1. 개인정보의 처리 목적',
        body: '자연담은은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.',
      },
      {
        heading: '2. 개인정보의 처리 및 보유기간',
        body: '자연담은은 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다. 회원 가입 및 관리: 회원 탈퇴 시까지 (단, 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지)',
      },
      {
        heading: '3. 처리하는 개인정보의 항목',
        body: '자연담은은 다음의 개인정보 항목을 처리하고 있습니다. 필수항목: 아이디, 이름, 전화번호. 선택항목: 이메일 주소, 주소. 서비스 이용 과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다: IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등',
      },
      {
        heading: '4. 개인정보의 제3자 제공',
        body: '자연담은은 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.',
      },
      {
        heading: '5. 개인정보의 파기',
        body: '자연담은은 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. 전자적 파일 형태의 정보는 기술적 방법을 사용하여 재생할 수 없도록 파기하며, 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.',
      },
      {
        heading: '6. 정보주체의 권리·의무 및 행사방법',
        body: '정보주체는 자연담은에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다. 1. 개인정보 열람요구 2. 오류 등이 있을 경우 정정 요구 3. 삭제요구 4. 처리정지 요구',
      },
      {
        heading: '7. 개인정보 보호책임자',
        body: '자연담은은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다. 개인정보 보호책임자: 자연담은 대표 / 이메일: homedr365@gmail.com / 전화: 02-3487-2025',
      },
    ],
  },
};

export default function TermsModal({ type, onClose }: TermsModalProps) {
  const content = TERMS_CONTENT[type];

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center px-4"
      onClick={onClose}
    >
      {/* 오버레이 */}
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm"></div>

      {/* 모달 */}
      <div
        className="relative bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-100 flex-shrink-0">
          <h3 className="text-base font-bold text-gray-900" style={{ fontFamily: 'Noto Serif KR, serif' }}>
            {content.title}
          </h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-700 hover:bg-gray-100 rounded-full transition-colors cursor-pointer"
            aria-label="닫기"
          >
            <i className="ri-close-line text-lg w-5 h-5 flex items-center justify-center"></i>
          </button>
        </div>

        {/* 본문 스크롤 영역 */}
        <div className="overflow-y-auto px-6 py-5 flex flex-col gap-5">
          {content.sections.map((section) => (
            <div key={section.heading}>
              <h4 className="text-sm font-bold text-gray-800 mb-1.5">{section.heading}</h4>
              <p className="text-xs text-gray-500 leading-relaxed">{section.body}</p>
            </div>
          ))}
          <p className="text-xs text-gray-400 pt-2 border-t border-gray-100">
            본 약관은 2024년 1월 1일부터 시행됩니다.
          </p>
        </div>

        {/* 하단 버튼 */}
        <div className="px-6 py-4 border-t border-gray-100 flex-shrink-0">
          <button
            onClick={onClose}
            className="w-full py-3 bg-emerald-600 text-white rounded-lg text-sm font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
